import React, { ReactElement } from 'react';

import classNames from 'classnames';

import { MODAL_CLASS, MODAL_CONTAINER_CLASS, NOOP } from '../../utils/constants';
import Flexbox from '../Flexbox/Flexbox';
import Loading from '../Loading/Loading';
import Label from '../Text/components/Label/Label';
import ActionBar from './components/ActionBar/ActionBar';
import Dialog from './components/Dialog/Dialog';
import TitleBar from './components/TitleBar/TitleBar';
import * as Styled from './Modal.styles';
import { IModalProps } from './Modal.types';

const Modal = ({
  children,
  className,
  open,
  title,
  description,
  padding = true,
  onClose = NOOP,
  showHeader = true,
  showFooter = true,
  showPrimaryAction,
  showSecondaryAction,
  primaryActionLabel,
  secondaryActionLabel,
  onPrimaryActionClick = onClose,
  onSecondaryActionClick = onClose,
  onPrimaryActionProps,
  onSecondaryActionProps,
  actionBarAlignment,
  headerAreaComponent,
  loading = false,
  loadingText = 'Loading...',
  ...props
}: IModalProps): ReactElement => (
  <Styled.Modal
    prefixCls={MODAL_CONTAINER_CLASS}
    className={classNames(MODAL_CLASS, className)}
    as={Dialog}
    visible={open}
    onClose={onClose}
    padding={padding}
    title={
      !loading &&
      showHeader && <TitleBar title={title} description={description} headerAreaComponent={headerAreaComponent} />
    }
    footer={
      !loading &&
      showFooter && (
        <ActionBar
          showPrimaryAction={showPrimaryAction}
          showSecondaryAction={showSecondaryAction}
          primaryActionLabel={primaryActionLabel}
          secondaryActionLabel={secondaryActionLabel}
          onPrimaryActionClick={onPrimaryActionClick}
          onSecondaryActionClick={onSecondaryActionClick}
          onPrimaryActionProps={onPrimaryActionProps}
          onSecondaryActionProps={onSecondaryActionProps}
          actionBarAlignment={actionBarAlignment}
        />
      )
    }
    {...props}
  >
    {loading ? (
      <Flexbox flexDirection="column" gap="12px" alignItems="center">
        <Loading size="large" />
        <Label size="large">{loadingText}</Label>
      </Flexbox>
    ) : (
      children
    )}
  </Styled.Modal>
);

export default Modal;
